// Calendar cross-module link vocabulary (W53.1 D-1 / ADR-0176).
//
// A calendar event can point at exactly one record in another module — an
// anniversary, a wish, a diary or an album — and three separate things need to
// know that mapping: the picker that offers them, the chip that says what is
// linked, and the deep link that opens it. All three used to carry their own
// copy (`SOURCE_ROUTE` was written out twice, and `album` had no label at all
// because albums are a link source but never a calendar category).
//
// The backend has always accepted all four (`calendar.SOURCE_TYPES`); the
// frontend offered one. That is the whole of D-1: `"album"` was a **literal**
// in `CalendarEventDetail.tsx`, so 「相關」 was a dead end for three quarters of
// what the API could already do.
//
// Adding a fifth module means adding one entry here — and `SOURCE_ROUTE` being
// typed against the union rather than `Record<string, string>` means forgetting
// the label is a type error instead of a chip that prints the raw enum, which
// is how `LinkedWishPanel` ended up showing `pending` to a user.

/** The four things a calendar event can be linked to. */
export const LINK_SOURCE_TYPES = ["album", "wish", "diary", "anniversary"] as const;

export type LinkSourceType = (typeof LINK_SOURCE_TYPES)[number];

/** Display name. Used by the picker's tabs and the 「查看關聯的 X 記錄」 chip. */
export const LINK_SOURCE_LABEL: Record<LinkSourceType, string> = {
  album: "相簿",
  wish: "心願",
  diary: "日記",
  anniversary: "紀念日",
};

/** Deep-link prefix for each type — the chip and the projection both use it. */
export const LINK_SOURCE_ROUTE: Record<LinkSourceType, string> = {
  album: "/albums/",
  wish: "/wishes/",
  diary: "/diaries/",
  anniversary: "/anniversaries/",
};

export function isLinkSourceType(value: string): value is LinkSourceType {
  return (LINK_SOURCE_TYPES as readonly string[]).includes(value);
}
